import React, { useEffect, useState } from 'react'
import { Routes, Route, Link } from 'react-router-dom';
// npm start
// npm run build

// prisma.io
// express js? mongodb? supabase?

// CSS/Sass
import 'bootstrap/dist/css/bootstrap.min.css';
import './components/App.scss';
import './components/Navbar.scss';
import './components/Sidebar.scss';

// Components
import Homepage from './components/Homepage'
import Sidebar from './components/Sidebar'
import Lost from './components/Lost'

import logo from './images/logo.png';
import logoname from './images/logoname.png';



export default function App() {
  document.title = "Sheed | Homepage";

  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  function scrollTo(event, section) {
    document.getElementById(section).scrollIntoView({ behavior: 'smooth' });
  }
  const [isLoading, setIsLoading] = useState(true);

  const Loader = () => {
    const loaderStyles = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      overflow: "hidden"
    };

    const spinnerStyles = {
      animation: "spin 1s linear infinite"
    };

    useEffect(() => {
      // Simulate a delay in loading the app
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }, []);

    return (
      <div style={loaderStyles}>
        <img
          src={logo}
          alt="loading" width={75}
          style={spinnerStyles}
        />
      </div>
    );
  };

  return (
    <>
      {isLoading ? <Loader /> :
        <>
          {/* <div className={scrollPosition > 500 ? "side-colorbar active" : "side-colorbar"}>
            <a href="#Recent-projects" className='side-colorbar-r'>R</a>
            <a href="#About" className='side-colorbar-a'>A</a>
            <a href="#" className='side-colorbar-s'>S</a>
            <a href="#HireMe" className='side-colorbar-h'>H</a>
            <a href="#Education" className='side-colorbar-e'>E</a>
            <a href="#Experience" className='side-colorbar-e2'>E</a>
            <a href="#About" className='side-colorbar-d'>D</a>
          </div> */}
          <nav className={scrollPosition > 500 ? "navbar active" : "navbar"} id="navbar">
            {/* <div className="navbar-left"> */}
            <Link id="homeLogo" to="/">
              <img src={logo} alt="Icon" className="logo" width={50} />
            </Link>

            {/* <a onClick={(e) => scrollTo(e, "Recent")} className="navbar-item"><span className='acronyms'>R</span><span className='means'>ecent Works</span></a>
          <a onClick={(e) => scrollTo(e, "Recent")} className="navbar-item"><span className='acronyms'>A</span><span className='means'>bout</span></a>
          <a onClick={(e) => scrollTo(e, "Skills")} className="navbar-item"><span className='acronyms'>S</span><span className='means'>kills</span></a>
          <a onClick={(e) => scrollTo(e, "Hire-me")} className="navbar-item"><span className='acronyms'>H</span><span className='means'>ire me</span></a>
          <a onClick={(e) => scrollTo(e, "Education")} className="navbar-item"><span className='acronyms'>E</span><span className='means'>ducation</span></a>
          <a onClick={(e) => scrollTo(e, "Experience")} className="navbar-item"><span className='acronyms'>E</span><span className='means'>xperience</span></a>
          <a onClick={(e) => scrollTo(e, "Discussion")} className="navbar-item"><span className='acronyms'>D</span><span className='means'>iscussion</span></a> */}
            {/* </div> */}


            {/* <button class="navbar-download largescreen">
          <span><svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 21h12M12 3v14m0 0l5-5m-5 5l-5-5" /></svg> RESUME</span>
        </button> */}

            <div className='non-largescreen'>
              <input type="checkbox" id="sidebar" />
              <label for="sidebar" class="menu-btn"><span></span></label>

              <label for="sidebar" class="close"></label>
              <div class="wrapper">
                <ul>
                  <li><a href="#Recent-projects" className='sidebar-r'><span className='acronyms'>R</span><span className='means'>ecent Works</span></a></li>
                  <li><a href="#About" className='sidebar-a'><span className='acronyms'>A</span><span className='means'>bout</span></a></li>
                  <li><a href="#" className='sidebar-s'><span className='acronyms'>S</span><span className='means'>kills</span></a></li>
                  <li><a href="#HireMe" className='sidebar-h'><span className='acronyms'>H</span><span className='means'>ire me</span></a></li>
                  <li><a href="#" className='sidebar-e'><span className='acronyms'>E</span><span className='means'>ducation</span></a></li>
                  <li><a href="#Experience" className='sidebar-e2'><span className='acronyms'>E</span><span className='means'>xperience</span></a></li>
                  <li><a href="#" className='sidebar-d'><span className='acronyms'>D</span><span className='means'>iscussion</span></a></li>
                  <li><img src={logo} alt="Icon" class="sidebar-logo" width={50} /></li>
                </ul>
              </div>
            </div>
            {/* <a class="navbar-more">
            <Hamburger rounded toggled={isOpen} toggle={setOpen} size={25}
              onToggle={toggled => {
                if (toggled) {
                  // open a menu
                } else {
                  // close a menu
                }
              }} />

          </a> */}



            {/* navbutton?
            inside dark/light mode */}

          </nav >

          < Routes >
            <Route path="/" element={<Homepage />} />
            <Route path="*" element={<Lost />} title="404" />
          </ Routes >
        </>
      }
    </>
  )
}

// export default App
// react.fragment or <>

